// Mock data for Joy Ogbekene Voiceover Website

export const siteConfig = {
  name: "Joy Ogbekene",
  title: "Professional Voice Artist",
  tagline: "A Voice That Commands Trust And Connects Across Cultures",
  subtagline: "Professional Nigerian & African Female Voice Artist",
  services: "Commercial • Corporate • IVR • Documentary • Promo",
  email: "contact@joyogbekene.com",
  phone: "+234 XXX XXX XXXX",
  heroImage: "https://customer-assets.emergentagent.com/job_a5aaf61b-66fa-4449-8c1c-ce3fd653ffd1/artifacts/m2sbj1t1_Joy-Ogbekene.jpg"
};

export const services = [
  {
    id: 1,
    title: "Commercial Voiceover",
    description: "Persuasive, relatable delivery that connects brands to real audiences.",
    icon: "Megaphone"
  },
  {
    id: 2,
    title: "Corporate Narration",
    description: "Clear, confident voice for internal and external business communication.",
    icon: "Building2"
  },
  {
    id: 3,
    title: "IVR & Telephone Systems",
    description: "Calm, professional tones that represent your brand perfectly.",
    icon: "Phone"
  },
  {
    id: 4,
    title: "Promo & Radio Imaging",
    description: "Dynamic energy for promos, jingles, and station branding.",
    icon: "Radio"
  },
  {
    id: 5,
    title: "Documentary & Storytelling",
    description: "Rich, engaging narration for long-form and broadcast projects.",
    icon: "Film"
  },
  {
    id: 6,
    title: "Nigerian Pidgin Voiceover",
    description: "Authentic delivery that resonates deeply with African audiences.",
    icon: "Globe"
  }
];

export const featuredDemos = [
  {
    id: 1,
    title: "3 in 1 Hot Chocolate",
    category: "Commercial",
    duration: "0:30",
    description: "Radio commercial - Warm, engaging delivery",
    audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/xsj44y8r_3%20in%201%20HOT%20CHOCOLATE%20HOTTIE%20NEW%20RADIO%20REVISION%20.mp3"
  },
  {
    id: 2,
    title: "Diamond Yellow",
    category: "Nigerian Pidgin",
    duration: "0:35",
    description: "Pidgin English commercial - Authentic African delivery",
    audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/wzhn0q2y_Diamond%20Yellow%20-%20Pidgin%20English%20-%20Commericial.mp3"
  },
  {
    id: 3,
    title: "IVR & Telephony",
    category: "IVR",
    duration: "0:45",
    description: "Professional English IVR prompts",
    audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/hqpnxmck_IVR%20%26%20Telephony%20-%20English.mp3"
  },
  {
    id: 4,
    title: "Maggie Commercial",
    category: "Nigerian Pidgin",
    duration: "0:28",
    description: "Pidgin English commercial - Relatable, warm tone",
    audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/leh6fqbe_Maggie%20-%20Pidgin%20English%20-%20Commericial.mp3"
  },
  {
    id: 5,
    title: "IVR Telephony Pidgin",
    category: "IVR",
    duration: "0:40",
    description: "Nigerian Pidgin IVR - Local authenticity",
    audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/mhld8xv7_IVR%20%26%20Telephony%20-%20Pidgin.mp3"
  }
];

export const allDemos = {
  commercial: [
    { id: 1, title: "3 in 1 Hot Chocolate", duration: "0:30", tone: "Warm, Engaging", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/xsj44y8r_3%20in%201%20HOT%20CHOCOLATE%20HOTTIE%20NEW%20RADIO%20REVISION%20.mp3" },
    { id: 2, title: "Diamond Yellow - Pidgin", duration: "0:35", tone: "Authentic, Relatable", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/wzhn0q2y_Diamond%20Yellow%20-%20Pidgin%20English%20-%20Commericial.mp3" },
    { id: 3, title: "Maggie - Pidgin", duration: "0:28", tone: "Warm, Conversational", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/leh6fqbe_Maggie%20-%20Pidgin%20English%20-%20Commericial.mp3" }
  ],
  corporate: [
    { id: 1, title: "WIPO GREEN Documentary", duration: "2:00", tone: "Professional, Informative", videoId: "X_0Xbpv07k4" },
    { id: 2, title: "Care's Women Economic Justice", duration: "1:30", tone: "Empowering, Warm", videoId: "g0A1xiyHbf8" }
  ],
  ivr: [
    { id: 1, title: "IVR & Telephony - English", duration: "0:45", tone: "Professional, Clear", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/hqpnxmck_IVR%20%26%20Telephony%20-%20English.mp3" },
    { id: 2, title: "IVR & Telephony - Pidgin", duration: "0:40", tone: "Friendly, Authentic", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/mhld8xv7_IVR%20%26%20Telephony%20-%20Pidgin.mp3" }
  ],
  promo: [
    { id: 1, title: "Pink Yoghurt 1 Liter TVC", duration: "0:30", tone: "Fresh, Energetic", videoId: "RX1wLggmFVE" },
    { id: 2, title: "MTN MoMo", duration: "0:45", tone: "Trustworthy, Modern", videoId: "RNwG-73j4yk" },
    { id: 3, title: "Golden Morn TVC", duration: "0:30", tone: "Warm, Family-oriented", videoId: "nYNHaOjzonw" }
  ],
  documentary: [
    { id: 1, title: "WIPO GREEN: Sustainable Technology", duration: "2:00", tone: "Informative, Engaging", videoId: "X_0Xbpv07k4" },
    { id: 2, title: "Gambia Health Survey", duration: "1:45", tone: "West African Accent, Professional", videoId: "7d74hnuqLr8" }
  ],
  pidgin: [
    { id: 1, title: "Diamond Yellow Commercial", duration: "0:35", tone: "Authentic Pidgin", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/wzhn0q2y_Diamond%20Yellow%20-%20Pidgin%20English%20-%20Commericial.mp3" },
    { id: 2, title: "Maggie Commercial", duration: "0:28", tone: "Relatable Pidgin", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/leh6fqbe_Maggie%20-%20Pidgin%20English%20-%20Commericial.mp3" },
    { id: 3, title: "IVR Telephony - Pidgin", duration: "0:40", tone: "Friendly Pidgin", audioUrl: "https://customer-assets.emergentagent.com/job_african-voice-pro/artifacts/mhld8xv7_IVR%20%26%20Telephony%20-%20Pidgin.mp3" }
  ]
};

export const youtubeVideos = [
  {
    id: 1,
    title: "Pink Yoghurt 1 Liter Drink TVC",
    embedId: "RX1wLggmFVE",
    description: "Television commercial - Fresh, engaging delivery"
  },
  {
    id: 2,
    title: "MTN MoMo",
    embedId: "RNwG-73j4yk",
    description: "Mobile money commercial - Trustworthy, modern tone"
  },
  {
    id: 3,
    title: "Golden Morn TVC",
    embedId: "nYNHaOjzonw",
    description: "Television commercial - Warm, family-oriented"
  },
  {
    id: 4,
    title: "WIPO GREEN: Sustainable Technology",
    embedId: "X_0Xbpv07k4",
    description: "Documentary narration - Informative, engaging"
  },
  {
    id: 5,
    title: "Gambia Health Survey",
    embedId: "7d74hnuqLr8",
    description: "West African accent - Professional narration"
  },
  {
    id: 6,
    title: "Nivea Black & White Deodorant",
    embedId: "NhrOeLGW0kI",
    description: "Urban African accent - Modern, confident"
  },
  {
    id: 7,
    title: "Mother's Day Dettol Ad",
    embedId: "WURjAXOr2S8",
    description: "Nigerian accent - Warm, emotional"
  },
  {
    id: 8,
    title: "Care's Women Economic Justice",
    embedId: "g0A1xiyHbf8",
    description: "Corporate narration - Empowering, professional"
  }
];

export const projectTypes = [
  "Commercial / Advertisement",
  "Corporate Narration",
  "IVR / Telephone System",
  "Documentary / Film",
  "Promo / Radio Imaging",
  "E-Learning / Training",
  "Audiobook",
  "Animation / Character",
  "Other"
];

export const usageTypes = [
  "Broadcast (TV/Radio)",
  "Digital / Online Only",
  "Internal / Corporate Use",
  "Social Media",
  "Cinema / Film",
  "Worldwide / All Media",
  "Regional / Limited Territory",
  "Other"
];

export const budgetRanges = [
  "Under $500",
  "$500 - $1,000",
  "$1,000 - $2,500",
  "$2,500 - $5,000",
  "$5,000 - $10,000",
  "$10,000+",
  "Not Sure / Need Quote"
];

export const galleryImages = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_a5aaf61b-66fa-4449-8c1c-ce3fd653ffd1/artifacts/m2sbj1t1_Joy-Ogbekene.jpg",
    alt: "Joy Ogbekene - Professional Portrait",
    caption: "Professional Studio Portrait"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_a5aaf61b-66fa-4449-8c1c-ce3fd653ffd1/artifacts/m2sbj1t1_Joy-Ogbekene.jpg",
    alt: "Recording Session",
    caption: "Recording Session"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_a5aaf61b-66fa-4449-8c1c-ce3fd653ffd1/artifacts/m2sbj1t1_Joy-Ogbekene.jpg",
    alt: "Studio Setup",
    caption: "Home Studio Setup"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_a5aaf61b-66fa-4449-8c1c-ce3fd653ffd1/artifacts/m2sbj1t1_Joy-Ogbekene.jpg",
    alt: "Behind the Scenes",
    caption: "Behind the Scenes"
  }
];

export const coreStrengths = [
  "Neutral English Accent",
  "African-Accented English",
  "Nigerian Pidgin",
  "Commercial Voiceover",
  "Corporate Narration",
  "IVR & Telephone Systems",
  "Documentary Narration",
  "Audio Branding",
  "Voiceover Direction & Consulting"
];

export const legalContent = {
  usage: {
    title: "Usage & Licensing",
    content: "All voiceover recordings are licensed for the specific usage agreed upon in the project brief. Usage rights are determined by media type (broadcast, digital, internal), territory (local, regional, international), and duration (1 year, 2 years, perpetual). Extended usage or additional territories require separate licensing agreements."
  },
  revisions: {
    title: "Revisions Policy",
    content: "Each project includes up to two (2) rounds of revisions at no additional cost, provided they fall within the original script and direction. Changes to the script, significant re-direction, or additional versions are quoted separately. Revision requests must be submitted within 7 days of delivery."
  },
  turnaround: {
    title: "Turnaround Time",
    content: "Standard delivery is 24-48 hours for projects under 500 words. Longer projects are scheduled based on scope. Rush delivery (same-day or next-day) is available for an additional fee of 50%. Weekend and holiday recordings are subject to availability and premium rates."
  },
  payment: {
    title: "Payment Terms",
    content: "A 50% deposit is required before recording begins. The remaining balance is due upon delivery of the final audio files. Accepted payment methods include bank transfer, PayPal, and major credit cards. International clients may be subject to wire transfer fees."
  },
  rights: {
    title: "Rights & Buyouts",
    content: "Standard licensing grants non-exclusive usage rights. Exclusive rights and full buyouts are available at additional cost. Exclusivity within a specific industry category can be negotiated. All buyout terms must be agreed upon in writing before project commencement."
  }
};

export const trustedBrands = [
  "MTN", "Shell", "First Bank", "Coca-Cola", "Dangote", "Access Bank"
];
